import React from "react";

import Box from "@material-ui/core/Box";
import PersonIcon from "@material-ui/icons/Person";
import PinDropIcon from "@material-ui/icons/PinDrop";

export default function SpamCounts({ spamCount }) {
  return (
    <Box display="flex" flexDirection="row">
      <Box display="flex" flexDirection="row" style={{ marginRight: 10 }}>
        <PersonIcon style={{ fontSize: 20, color: "#C2C2C2" }} />
        {` : ${spamCount.user}`}
      </Box>
      <Box display="flex" flexDirection="row">
        <PinDropIcon style={{ fontSize: 20, color: "#C2C2C2" }} />
        {` : ${spamCount.travelCard}`}
      </Box>
    </Box>
  );
}
